<img
  (click)="openModal()"
  [imageLoader]="lastPP()"
  class="rounded-circle profileimg"
  [ngClass]="{ pointer: editAcces() }"
  alt="{{ 'Image' | appTranslate | async }}" />